import { render } from "./whiterecord.vue?vue&type=template&id=c4640364"
import script from "./whiterecord.vue?vue&type=script&lang=js"
export * from "./whiterecord.vue?vue&type=script&lang=js"
script.render = render

export default script